import { combineReducers } from 'redux';
import currentUserReducer from './CurrentUser.reducer';
import streamingReducer from './Streaming.reducer';
import categoriesReducer from './Categories.reducer';
import languagesReducer from './Languages.reducer';
import rallyReducer from './Rally.reducer';

const rootReducer = combineReducers({
    currentUser: currentUserReducer,
    streaming: streamingReducer,
    categories: categoriesReducer,
    languages: languagesReducer,
    rally: rallyReducer,
});

export default rootReducer;
